import { Action, Dispatch } from 'redux';
import { get } from 'components/Shared/server';
import { ConservatoryDesignModel } from 'models/ConservatoryDesignModel';

const RESPONSESTATUS_SUCCESS = 200;

export const GUIDE_DESIGN_DATA_LOADING = 'GUIDE_DESIGN_DATA_LOADING';
export const GUIDE_DESIGN_DATA_LOADED = 'GUIDE_DESIGN_DATA_LOADED';
export const GUIDE_DESIGN_PRODUCTS_BY_OPENING_SIZE = 'GUIDE_DESIGN_PRODUCTS_BY_OPENING_SIZE';
export const GUIDE_DESIGN_SELECT_PRODUCT = 'GUIDE_DESIGN_SELECT_PRODUCT';
export const GUIDE_DESIGN_SELECT_TYPE = 'GUIDE_DESIGN_SELECT_TYPE';
export const GUIDE_DESIGN_SELECT_COLOR = 'GUIDE_DESIGN_SELECT_COLOR';
export const GUIDE_DESIGN_VALID = 'GUIDE_DESIGN_VALID';
export const GUIDE_DESIGN_INVALID = 'GUIDE_DESIGN_INVALID';
export const GUIDE_DESIGN_CLOSE_OPENING_SELECTOR = 'GUIDE_DESIGN_CLOSE_OPENING_SELECTOR';

export interface ConservatoryDesignAction extends Action {
  data: ConservatoryDesignModel;
}

export interface ConservatoryDesignProductsByOpeningSizeAction extends Action {
  id: string;
}

export interface ConservatoryDesignCloseOpeningSelectorAction extends Action {
  id: string;
  useSameColor: boolean;
}

export interface ConservatoryDesignSelectProductAction extends Action {
  id: string;
  productId: string;
}

export interface ConservatoryDesignSelectTypeAction extends Action {
  name: string;
}

export interface ConservatoryDesignSelectColorAction extends Action {
  productId: string;
}

export const guideDesignValid = () => ({
  type: GUIDE_DESIGN_VALID
});

export const guideDesignInValid = () => ({
  type: GUIDE_DESIGN_INVALID
});

export const guideDesignSelectProduct = (id: string, productId: string) => ({
  type: GUIDE_DESIGN_SELECT_PRODUCT,
  id,
  productId
});

export const guideDesignProductsByOpeningSize = (id: string) => ({
  type: GUIDE_DESIGN_PRODUCTS_BY_OPENING_SIZE,
  id
});

export const guideDesignCloseOpeningSelector = (id: string, useSameColor: boolean) => ({
  type: GUIDE_DESIGN_CLOSE_OPENING_SELECTOR,
  id,
  useSameColor
});

export const guideDesignSelectType = (name: string) => ({
  type: GUIDE_DESIGN_SELECT_TYPE,
  name
});

export const guideDesignSelectColor = (productId: string) => ({
  type: GUIDE_DESIGN_SELECT_COLOR,
  productId
});

export const guideDesignDataloaded = (data: ConservatoryDesignModel | undefined) => ({
  type: GUIDE_DESIGN_DATA_LOADED,
  data
});

export const guideDesignDataloading = () => ({
  type: GUIDE_DESIGN_DATA_LOADING,
  openings: undefined
});

export const guideDesignFetchData = (
  baseProductId: string,
  articleGroup: string,
  season: string
) => {
  return (dispatch: Dispatch) => {
    dispatch(guideDesignDataloading());

    if (articleGroup.length < 1 || baseProductId.length < 1) {
      dispatch(guideDesignDataloaded(undefined));
      return;
    }

    void get({
      url: `/conservatory/getdesigndata?baseProductId=${baseProductId}&artGrp=${articleGroup}&season=${encodeURI(
        season
      )}`
    })
      .then(response => {
        if (response.status !== RESPONSESTATUS_SUCCESS) {
          dispatch(guideDesignDataloaded(undefined));
          return;
        }

        return response.json();
      })
      .then((data: ConservatoryDesignModel) => {
        dispatch(guideDesignDataloaded(data));
      });
  };
};
